import { render, staticRenderFns } from "./Reputation.vue?vue&type=template&id=39c99d92&scoped=true&"
import script from "./Reputation.vue?vue&type=script&lang=js&"
export * from "./Reputation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39c99d92",
  null
  
)

export default component.exports